/* 购物车快捷支付钱包按钮排序：Shop Pay → Apple Pay → 其他钱包 → CHECKOUT（信用卡，位于按钮下方）。
   背景：钱包按钮渲染在 <shopify-accelerated-checkout-cart> 的闭包 shadow DOM 网格
   （.wallet-cart-grid > .wallet-cart-button-container > <slot name="button-XXX">）里，
   主题层无法穿透闭包改单元格顺序；但按钮本体是宿主的 light-DOM 子元素，
   通过 slot 属性分配到单元格——交换 slot 属性即可交换渲染位置，
   不移动 DOM 节点（iframe 不重载），也不依赖 shadow 内部结构。
   顺序判定基于实际渲染位置（getBoundingClientRect），已正确则不做任何写操作。 */
(function() {
  'use strict';

  var hostSelector = 'shopify-accelerated-checkout-cart';

  /* 钱包优先级：数值越小越靠前；未列出的钱包排在已知钱包之后（保持原有相对顺序） */
  var walletPriority = {
    'SHOP-PAY-WALLET-BUTTON': 0,
    'SHOPIFY-APPLE-PAY-BUTTON': 1,
    'SHOPIFY-PAYPAL-BUTTON': 2,
    'SHOPIFY-GOOGLE-PAY-BUTTON': 3,
    'SHOPIFY-AMAZON-PAY-BUTTON': 4
  };

  /* 防御：若组件侧持续重置 slot 导致乒乓交换，短时间内超过阈值即放弃该宿主 */
  var MAX_SWAPS = 6;
  var SWAP_WINDOW = 3000;

  function priorityOf(el) {
    var p = walletPriority[el.tagName];
    return typeof p === 'number' ? p : 99;
  }

  function walletButtons(host) {
    return Array.prototype.filter.call(host.children, function(el) {
      return el.nodeType === 1 && el.hasAttribute('slot');
    });
  }

  function isLaidOut(el) {
    var r = el.getBoundingClientRect();
    return r.width > 0 || r.height > 0;
  }

  function visualOrder(a, b) {
    var ra = a.getBoundingClientRect();
    var rb = b.getBoundingClientRect();
    if (Math.abs(ra.top - rb.top) > 4) return ra.top - rb.top; /* 纵向堆叠 */
    return ra.left - rb.left; /* 横向网格（同一行按左右） */
  }

  function tooManySwaps(host) {
    if (!host.__walletOrderSwaps) host.__walletOrderSwaps = [];
    var now = Date.now();
    host.__walletOrderSwaps = host.__walletOrderSwaps.filter(function(t) {
      return now - t < SWAP_WINDOW;
    });
    return host.__walletOrderSwaps.length >= MAX_SWAPS;
  }

  /* 返回 true 表示已处理完成（顺序已符合或已完成一次交换）；false 表示按钮尚未就绪，需重试 */
  function enforce(host) {
    var buttons = walletButtons(host);
    if (buttons.length < 2) return false;
    if (!buttons.every(isLaidOut)) return false;
    if (tooManySwaps(host)) return true;

    var current = buttons.slice().sort(visualOrder);
    var desired = buttons.slice().sort(function(a, b) {
      var diff = priorityOf(a) - priorityOf(b);
      return diff !== 0 ? diff : current.indexOf(a) - current.indexOf(b);
    });

    var changed = desired.some(function(el, i) {
      return el !== current[i];
    });
    if (!changed) return true;

    /* 把"第 i 个位置当前占用的 slot 名"重新分配给"期望排在第 i 位的按钮" */
    desired.forEach(function(el, i) {
      el.setAttribute('slot', current[i].getAttribute('slot') || '');
    });
    host.__walletOrderSwaps.push(Date.now());
    return true;
  }

  function watch(host) {
    if (host.__walletOrderWatched) return;
    host.__walletOrderWatched = true;

    var pending = false;
    var observer = new MutationObserver(function() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function() {
        pending = false;
        enforce(host);
      });
    });
    observer.observe(host, { childList: true, attributes: true, attributeFilter: ['slot'] });
  }

  function initHost(host) {
    watch(host);

    /* 钱包按钮在 web component 注册后异步挂载。轮询做指数退避（50ms 起步、500ms 封顶），
       让首次交换尽早落在骨架屏阶段——真实 iframe 徽标加载完成前顺序已就位，用户无感知；
       总等待窗口约 20s，未挂载（如加速结账关闭）则静默退出。 */
    var delay = 50;
    var waited = 0;
    (function retry() {
      if (enforce(host)) return;
      waited += delay;
      if (waited > 20000) return;
      setTimeout(retry, delay);
      delay = Math.min(delay * 2, 500);
    })();
  }

  function init() {
    Array.prototype.forEach.call(
      document.querySelectorAll(hostSelector),
      initHost
    );

    /* 购物车页 / 抽屉经 Section Rendering API 重建后，重新接管新挂载的宿主 */
    var docObserver = new MutationObserver(function() {
      Array.prototype.forEach.call(document.querySelectorAll(hostSelector), function(host) {
        if (!host.__walletOrderWatched) initHost(host);
      });
    });
    if (document.body) {
      docObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
